<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="2"></ucMenu>
					<div class="right_con">
						<div class="goods_main" v-loading="isLoading">
							<p class="fb">商品中心</p>

              <!-- goods list query start -->
              <div v-if="[0,1,2].includes(state)">
                <div class="select_wrap">
                  <!-- <el-select class="w290 mr" v-model="searchData.dangkou_id" placeholder="请选择" clearable filterable >
                    <p slot="prefix" class="label_title">档口</p>
                    <el-option v-for="item in dangkouList" :key="item.dangkou_id" :label="item.full_txt" :value="item.dangkou_id">
                    </el-option>
                  </el-select> -->
									<el-select class="w290 mr" v-model="searchData.shop_id" placeholder="请选择" clearable filterable >
									  <p slot="prefix" class="label_title">店铺名</p>
									  <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
									  </el-option>
									</el-select>
                  <el-input class="w290 mr" v-model="searchData.name" placeholder="请输入商品名称" clearable>
                    <p slot="prefix" class="label_title">商品名称</p>
                  </el-input>
                  <el-input class="w290 mr" v-model="searchData.product_id" placeholder="请输入商品ID" clearable>
                    <p slot="prefix" class="label_title">商品ID</p>
                  </el-input>
                  <div class="w290 mr">
                    <p  class="label_title cate-label">分类</p>
                    <el-cascader
                        v-model="searchData.cate_id"
                        placeholder="请选择"
                        :props="cateProps"
                        clearable
                        filterable>
                    </el-cascader>
                  </div>
                  <el-date-picker class="mr w290"
                                  v-model="searchData.search_date"
                                  type="datetimerange"
                                  align="right"
                                  unlink-panels
                                  range-separator="至"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  :picker-options="pickerOptions"
                                  :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
                  <el-button plain size="small" @click="getList">查询</el-button>
                  <el-button plain size="small" @click="resetSearch">重置</el-button>
                </div>
              </div>
              <!-- goods list query end -->

              <!-- puhuo error query start -->
              <div v-if="[100].includes(state)">
                <div class="select_wrap">
                  <el-input class="w290 mr" v-model="ph_searchData.product_name" placeholder="请输入商品名称" clearable>
                    <p slot="prefix" class="label_title">商品名称</p>
                  </el-input>
                  <el-input class="w290 mr" v-model="ph_searchData.error" placeholder="请输入失败原因" clearable>
                    <p slot="prefix" class="label_title">失败原因</p>
                  </el-input>
                  <el-select class="w290 mr" v-model="ph_searchData.shop_id" placeholder="请选择" clearable filterable >
                    <p slot="prefix" class="label_title">店铺</p>
                    <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
                    </el-option>
                  </el-select>
                  <el-date-picker class="mr w290"
                    v-model="ph_searchData.search_date"
                    type="datetimerange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                  <el-button plain size="small" @click="getPuhuoList">查询</el-button>
                  <el-button plain size="small" @click="resetPuhuoSearch">重置</el-button>
                </div>
              </div>
              <!-- puhuo error query end -->

							<div class="tabs_wrap">
								<p class="tab" :class="state==0?'active':''" @click="bindSate(0)">全部商品</p>
								<p class="tab" :class="state==1?'active':''" @click="bindSate(1)">已上架</p>
								<p class="tab" :class="state==2?'active':''" @click="bindSate(2)">仓库中</p>
                <p class="tab" :class="state==100?'active':''" @click="bindSate(100)">铺货失败</p>
							</div>

              <!-- goods list start -->
              <div v-if="[0,1,2].includes(state)">
                <div class="totals_btn">
                  <p class="totals">共{{page_data.total}}条</p>
                  <el-button plain size="small" @click="postBatOnSale()">批量上架</el-button>
                  <el-button plain size="small" @click="postBatOffSale()">批量放入仓库</el-button>
                  <el-button plain size="small" @click="bindBatEditPrice()">批量修改价格</el-button>
                  <el-button plain size="small" @click="postBatDel()">批量删除</el-button>
                  <el-button plain size="small" @click="postSyncProduct"><i class="el-icon-loading" v-if="queue_num>0"></i>{{queue_num>0?'正在同步':'一键同步'}}</el-button>
									<el-button plain size="small" @click="bindProductInviteCode()">设置邀请码</el-button>
                </div>
                <div class="list_title">
                  <el-table
                      :header-row-style="{background:'#f9f9f9', color:'#666', 'line-hight':'50px', 'height': '50px','text-align':'center'}"
                      :data="list"
                      @selection-change="selection" row-key="product_id"
                      v-loading="isLoading"
                      style="width: 100%">
                    <el-table-column align="left" type="selection" width="50"></el-table-column>
                    <el-table-column prop="product_id" width="60"></el-table-column>
                    <el-table-column
                        prop="scope"
                        label="货品信息"
                        width="320">
                      <template slot-scope="scope">
                        <div class="product-info">
                          <el-image class="coverimg" fit="contain" :src="scope.row.img">
                            <div slot="error" class="image-slot">
                              <i class="el-icon-picture-outline"></i>
                            </div>
                          </el-image>
                          <div class="name-wrap">
                            <div class="name" :title="scope.row.name">{{scope.row.name}}
                              <!-- <p class="edit-title"><el-link icon="el-icon-edit"></el-link></p> -->
                            </div>
                            <div class="id">ID:{{scope.row.source_product_id}}</div>
                          </div>
                        </div>

                      </template>
                    </el-table-column>
                    <!-- <el-table-column
                      prop="scope"
                      label="原价"
                      width="100">
                      <template slot-scope="scope">
                          {{scope.row.purchase_price}}
                      </template>
                    </el-table-column> -->
                    <el-table-column
                        prop="scope"
                        label="卖价"
                        width="100">
                      <template slot-scope="scope">
                        {{scope.row.discount_price}}
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="scope"
                        label="商品状态">
                      <template slot-scope="scope">
                        <p class="status sales" v-if="scope.row.status == 0">{{scope.row.status_text}}</p>
                        <p class="status fail" v-if="scope.row.status == 2">{{scope.row.status_text}}</p>
                        <p class="status xiajia" v-if="scope.row.status == 1">{{scope.row.status_text}}</p>
                      </template>
                    </el-table-column>
                    <el-table-column
                        prop="createtime"
                        label="时间"
                        width="150">
                    </el-table-column>

                    <el-table-column
                        prop="scope"
                        label="操作">
                      <template slot-scope="scope">
                        <!-- <router-link :to="{name:'uc_goods_edit',params:{setid:1111222}}">
                          <p class="opts green">编辑</p>
                        </router-link> -->
                        <p class="opts green" @click="bindEditInfo(scope.row)">编辑</p>
                        <p class="opts" style="margin-left: 10px;" @click="bindDel(scope.row.product_id)">删除</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" />
              </div>
              <!-- goods list end -->


              <!-- puhuo error start -->
              <div v-if="[100].includes(state)">
                <div class="totals_btn">
                  <p class="totals">共{{page_data.total}}条</p>
                  <el-button plain size="small" @click="batExportPh()">批量导出</el-button>
                  <el-button plain size="small" @click="postBatDelPh()">批量删除</el-button>
                </div>
                <div class="list_title">
                  <el-table
                      :header-row-style="{background:'#f9f9f9', color:'#666', 'line-hight':'50px', 'height': '50px','text-align':'center'}"
                      :data="ph_list"
                      @selection-change="phSelection" row-key="id"
                      v-loading="isLoading"
                      style="width: 100%">
                    <el-table-column align="center" type="selection" width="42"></el-table-column>
                    <el-table-column align="center" type = '' property="id" label="序号" show-overflow-tooltip width="70">
                    </el-table-column>
                    <el-table-column align="center"  property="scope" label="类型" show-overflow-tooltip width="100">
                      <template slot-scope="scope">
                        {{scope.row.puhuo_error_tag?scope.row.puhuo_error_tag.type_text:'未知'}}
                      </template>
                    </el-table-column>
                    <el-table-column align="left"  property="scope" label="标签" show-overflow-tooltip width="150">
                      <template slot-scope="scope">
                        {{scope.row.puhuo_error_tag?scope.row.puhuo_error_tag.content:'无'}}
                      </template>
                    </el-table-column>
                    <el-table-column align="left"  property="dd_name" label="商品分类" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column align="left"  property="product_name" label="商品名称" show-overflow-tooltip width="200">
                      <template slot-scope="scope">
                        <el-link :href="scope.row.product_link" target="_blank">{{scope.row.product.product?scope.row.product.product.name:'商品已删除'}}</el-link>
                      </template>
                    </el-table-column>
                    <el-table-column align="left"  property="shop_name" label="供应商抖店" show-overflow-tooltip width="110"></el-table-column>
                    <el-table-column align="left"  property="scope" label="供应商商品ID" show-overflow-tooltip width="200">
                      <template slot-scope="scope">
                        {{scope.row.product.product?scope.row.product.product.source_product_id:'商品已删除'}}
                      </template>
                    </el-table-column>
                    <el-table-column align="center"  property="scope" label="更新时间" show-overflow-tooltip width="200">
                      <template slot-scope="scope">
                        {{scope.row.update_time}}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="100">
                      <template slot-scope="scope">
                        <div>

                          <p class="opts" @click="delPh(scope.row.id)" >删除</p>
                        </div>
                      </template>
                    </el-table-column>

                  </el-table>
                </div>

                <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getPuhuoList" />
              </div>
              <!-- puhuo error end -->


						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 批量改价弹窗 -->
		<el-dialog title="批量改价" :visible.sync="dialog.editPriceDialog" width="30%" center >
			<pricePloy @submit="postBatEditPrice" @close="dialog.editPriceDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.editPriceDialog"></pricePloy>
		</el-dialog>
		<!-- 编辑标题 -->
		<el-dialog title="修改商品信息" :visible.sync="dialog.editInfoDialog" width="30%" center >
			<editInfo @submit="postEditInfo" @close="dialog.editInfoDialog = false" :isLoading.sync="isLoading" :show.sync="dialog.editInfoDialog" :product.sync="row"></editInfo>
		</el-dialog>
		<!-- 同步订单弹窗 -->
		<syncProduct @close="refresh()" :isLoading.sync="isLoading" :show.sync="dialog.syncProductDialog" ></syncProduct>
		<!-- 设置邀请码 -->
		<productInviteCode @close="dialog.editProductInviteCodeDialog=false" :isLoading.sync="isLoading" :show.sync="dialog.editProductInviteCodeDialog" ></productInviteCode>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
import common from '@/assets/js/utils/common.js'
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';
import pricePloy from '../../components/pricePloy/pricePloy';
import editInfo from '../../components/editInfo/editInfo';
import syncProduct from '../../components/syncProduct/syncProduct';
import {productLeafCateList} from "../../api/main/ucenter.js";
import productInviteCode from '../../components/productInviteCode/productInviteCode'
export default {
	name: "ucenterGoods",
	components:{
		myHead,myFoot,ucMenu,Pagination,pricePloy,editInfo,syncProduct,productInviteCode
	},
	data() {
		return {
			isLoading: false,
			// cateList: [],
			cateProps: {
				lazy: true,
				checkStrictly: true,
				// expandTrigger: 'hover',
				lazyLoad (node, resolve) {
					var cate = node?node:{value:0,level:1};
					var param = {pid:cate.value,level:cate.level+1}
						productLeafCateList(param).then(res => {
						if(res.code == 200){
							let list = res.data.cate_list
							// console.log('leaf_list:',list)
							const nodes = Array.from(list)
								.map(item => ({
									value: item.value,
									label: item.label,
									level: item.level,
									leaf: item.leaf==1?0:1,//0为有下级 1为没有
								}));
							// console.log(nodes)
							resolve(nodes);
						}
					})

				}
			},
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			searchData:{},
      ph_searchData:{},
			state:0,
			ids:'',
      ph_ids: '',
			list:[],
      ph_list: [],
      shop_list: [],
			page_data: {
				limit: 10,
				page: 1,
				total:0,
			},
			dialog: {
				addDialog:false,
				editPriceDialog:false,
				editInfoDialog:false,
				syncProductDialog:false,
				editProductInviteCodeDialog:false,
			},
			itv_auto_refresh:0,
			form:{
				title:'',
				product_urls:''
			},

			row:{},
			dangkouList:[],
			shopList: [],
			queue_num: 0,
		}
	},
	created() {
		this.initData()
		this.getList()
	},
	destroyed() {
	},
	methods: {
		...mapActions({
			getProductList:"ucenter/getProductList",
      getPuhuoErrorCollectList:"ucenter/getPuhuoErrorCollectList",
      opDeletePhError:"ucenter/opDeletePhError",
			opProductDel:"ucenter/opProductDel",
			opProductBatOnSale:"ucenter/opProductBatOnSale",
			opProductBatOffSale:"ucenter/opProductBatOffSale",
			getProductFilterData:"ucenter/getProductFilterData",
			getProductLeafCateList:"ucenter/getProductLeafCateList",
			opBatProductEditPrice:"ucenter/opBatProductEditPrice",
			opProductEditInfo:"ucenter/opProductEditInfo",
			opSyncProduct:"ucenter/opSyncProduct"
		}),
		bindProductInviteCode(){
			this.dialog.editProductInviteCodeDialog = true
		},
		selection(selection) {
			this.ids = selection.map(item => item.product_id)
		},

    phSelection(selection) {
      this.ph_ids = selection.map(item => item.product_id)
    },
		postSyncProduct(){

			this.dialog.syncProductDialog = true
		},
		//重置搜索
		resetSearch(){
			this.page_data.page = 1
			this.searchData = {}
			this.getList()
		},
    //重置铺货搜索
    resetPuhuoSearch(){
      this.page_data.page = 1
      this.ph_searchData = {}
      this.getPuhuoList()
    },
		//刷新列表
		refresh(){
			// this.page_data.page = 1
			this.dialog.syncProductDialog = false
			this.getList()
      this.getPuhuoList();
		},

		initData(){
			this.getProductFilterData({data:{},success:(res)=>{
				if(res.code===200){
					// console.log('get goods filter data',res)
					// this.cateList = res.data.cate_list
					// this.dangkouList = res.data.dangkou_list
					this.shopList = res.data.dd_shop_list
				}
			}})
		},
		//获取商品列表
		getList(showLoading = true){
			if(showLoading) this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page,state:this.state}
			Object.assign(param, this.searchData)
			// console.log(param)
			this.getProductList({data:param,success:(res)=>{
				if(res.code===200){
					// console.log('get list',res.data.data)
					this.list = res.data.data
					this.page_data.total = res.data.total
					this.queue_num = res.data.queue_num
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.isLoading = false
			}})
		},
    getPuhuoList(showLoading = true){
      if(showLoading) this.isLoading = true
      let param = {limit:this.page_data.limit,page:this.page_data.page}
      Object.assign(param, this.ph_searchData)
      // console.log(param)
      this.getPuhuoErrorCollectList({data:param,success:(res)=>{
          if(res.code===200){
            this.ph_list = res.data.data
            this.page_data.total = res.data.total

            if(res.data.current_page === 1){
              this.shop_list = res.data.field_list.shop_ids;
            }
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
          this.isLoading = false
        }})

    },
		//切换商品状态
		bindSate(e){
			this.state = e
      if([0, 1, 2].includes(e)){
        this.page_data.page = 1;
        this.getList()
      }
			if([100].includes(e)){
        this.page_data.page = 1;
        this.getPuhuoList();
      }
		},

		bindDel(id){
			this.ids = [id]
			this.postBatDel()
		},

		//删除
		postBatDel(){
			let that = this
			let ids = that.ids
			// console.log(ids)
			if(ids.length == 0){
				that.$message({message: '请勾选商品',type: 'error'})
				return;
			}
			that.$confirm('确认删除选中商品吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.isLoading = true
				let param = {product_id:ids.join(',')}
				that.opProductDel({data:param,success:(res)=>{
					// console.log(res)
					that.isLoading = false
					if(res.code == 200){
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		},


    //删除铺货失败
    postBatDelPh(){
      if(this.ph_ids.length < 1){
        return this.$message({message: '请勾选记录',type: 'warning'});
      }
      this.delPh(this.ph_ids.join(','));
    },

    delPh(id){
      this.$confirm('确认删除选中记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        this.opDeletePhError({
          data:{id: id},
          success:()=>{
            this.isLoading = false
            this.getPuhuoList(false);
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          }
        })
      })
    },
    // 批量导出铺货
    batExportPh(){
      if(this.isLoading) return
      this.isLoading = true
      let param = {limit:this.page_data.limit,page:this.page_data.page,is_export:1,ids:this.checkList}
      Object.assign(param, this.ph_searchData)
      this.getPuhuoErrorCollectList({data:param,success:(res)=>{
          if(res.code===200){
            window.open(res.data)
          } else {
            this.$message({message: res.msg,type: 'error',});
          }
          this.isLoading = false
        }})
    },


		//修改标题弹窗
		bindEditInfo(row){
			this.row = row
			this.ids = row.product_id
			this.dialog.editInfoDialog = true
		},
		//提交修改信息
		postEditInfo(e){
			let that = this
			console.log(e)
			that.opProductEditInfo({data:e,success:(res)=>{
				that.isLoading = false
				if(res.code == 200){
					that.$message({
						type: 'success',
						message: res.msg
					})
					that.refresh()
					that.dialog.editInfoDialog = false
				}else{
					that.$message({
						type: 'error',
						message: res.msg
					})
				}
			}})
		},

		//批量改价弹窗
		bindBatEditPrice(){
			let that = this
			let ids = that.ids
			if(ids.length == 0){
				that.$message({message: '请勾选商品',type: 'error'})
				return;
			}
			this.dialog.editPriceDialog = true
		},
		//提交批量改价
		postBatEditPrice(e){
			let that = this
			let ids = that.ids
			let param = {product_id:ids.join(',')}
			Object.assign(param, e)
			that.opBatProductEditPrice({data:param,success:(res)=>{
				that.isLoading = false
				that.dialog.editPriceDialog = false
				if(res.code == 200){
					that.$message({
						type: 'success',
						message: res.msg
					})
					that.refresh()
				}else{
					that.$message({
						type: 'error',
						message: res.msg
					})
				}
			}})
		},
		//批量上架
		postBatOnSale(){
			let that = this
			let ids = that.ids
			if(ids.length == 0){
				that.$message({message: '请勾选商品',type: 'error'})
				return;
			}
			that.$confirm('确认上架选中商品吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.isLoading = true
				let param = {product_id:ids.join(',')}
				that.opProductBatOnSale({data:param,success:(res)=>{
					// console.log(res)
					that.isLoading = false
					if(res.code == 200){
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		},
		//批量下架
		postBatOffSale(){
			let that = this
			let ids = that.ids
			if(ids.length == 0){
				that.$message({message: '请勾选商品',type: 'error'})
				return;
			}
			that.$confirm('确认下架选中商品吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.isLoading = true
				let param = {product_id:ids.join(',')}
				that.opProductBatOffSale({data:param,success:(res)=>{
					// console.log(res)
					that.isLoading = false
					if(res.code == 200){
						that.$message({
							type: 'success',
							message: res.msg
						})
						that.refresh()
					}else{
						that.$message({
							type: 'error',
							message: res.msg
						})
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		},

	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 28px 0 40px;display: flex;justify-content: space-between;flex: 1;min-height: 500px;}
.right_con{width: 980px;background: #fff;}
.goods_main{padding: 36px 40px 46px;}
.select_wrap{margin-top: 24px;display: flex;flex-wrap: wrap;}
.select_wrap .mr{margin-right: 10px;}
.select_wrap .w290{width: 290px !important;margin-top: 14px;position: relative;}
.select_wrap .cate-label{position: absolute;left: 5px;z-index: 1;padding-left: 10px;}
.select_wrap .label_title{width: 76px;height: 100%;font-size: 12px;color: #999;display: flex;align-items: center;padding-left: 6px;}
.tabs_wrap{width: 100%;height: 60px;border-bottom: 1px solid #eee;display: flex;}
.tabs_wrap .tab{height: 100%;padding: 30px 16px 0;position: relative;line-height: 1;cursor: pointer;font-size: 14px;color: #666;box-sizing: border-box;}
.tabs_wrap .tab.active{font-weight: bold;color: var(--red);}
.tabs_wrap .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
.totals_btn{margin-top: 14px;display: flex;align-items: center;}
.totals_btn .totals{font-size: 12px;color: #333;padding-right: 16px;margin-right: 16px;line-height: 1;border-right: 1px solid #ccc;}

.list_title{margin-top: 10px;}
.list_title .status{width: 80px;display: flex;justify-content: flex-start;align-items: center;}
.list_title .status::before{content: '';width: 8px;height: 8px;border-radius: 50%;margin-right: 6px;}
.list_title .status.sales::before{background: #0ea11f;}
.list_title .status.xiajia::before{background: #ccc;}
.list_title .status.fail::before{background: var(--red);}
.list_title .status.fail{color: var(--red);}
.list_title .time{width: 60px;line-height: 16px;margin: 0 20px;}
.list_title .guanlian{color: #1966ff;cursor: pointer;}
.list_title .guanlian:hover{text-decoration: underline;}
.list_title .opts{color: var(--red);cursor: pointer;margin-top: 6px;display:inline-block;margin-right: 10px;}
.list_title .opts.green{color: #0ea11f;}
.list_title .opts:hover{text-decoration: underline;}
.list_title .product-info{display: flex;}
.list_title .product-info .coverimg{width: 60px;height: 60px;border-radius: 5px;background-color: #f0f0f0;}
.list_title .product-info .name-wrap{display: flex;flex-direction: column;margin-left: 10px;text-align: left;}
.list_title .product-info .name-wrap .name{width: 200px;display:-webkit-box;-webkit-box-orient:vertical; -webkit-line-clamp:2; text-overflow:ellipsis;overflow: hidden;position: relative;}
.list_title .product-info .name-wrap .name .edit-title{position: absolute;right: 0;top: 22px;}
.list_title .product-info .name-wrap .id{width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #999;}

.header-row{background-color: #f9f9f9;}
.el-table .warning-row {background: oldlace;}
.el-table .success-row {background: #f0f9eb;}


.opts_wrap{padding-top: 14px;}
.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;}
.opts_line .txt{width: 110px;text-align: right;font-size: 14px;}
.opts_line .con{flex: 1;width: 0;margin-left: 22px;display: flex;align-items: center;}
.opts_line .con .t{font-size: 14px;color: var(--red);text-decoration: underline;cursor: pointer;}
.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
.ml8{margin-left: 8px;}
.w100{width: 100%;}
.el-input{width: unset !important; }
/deep/.el-input__prefix{left: 15px;}
</style>
<style>

.select_wrap .el-button{margin-top: 14px;margin-right:10px;margin-left: 0 !important;}
.el-input--prefix .el-input__inner,.el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}
.mr10{margin-right: 10px;}
/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}

.el-table th.el-table__cell{background-color: unset;}
.el-table th.el-table__cell>.cell{padding-left: 14px;padding-right: 14px;}

.el-cascader{width: 100%;height: 34px;line-height: 34px;}

.el-date-editor .el-range-separator{line-height: 26px;}
.el-date-editor{width:290px !important;height: 34px !important;line-height: 34px !important;font-size: 12px !important;margin-top: 14px;}
.el-range-editor.is-active, .el-range-editor.is-active:hover{border-color: var(--red);}
.el-date-table td.end-date span, .el-date-table td.start-date span{background-color: var(--red);}
.el-date-table td.today span{color: var(--red);}
.el-picker-panel__icon-btn:hover,.el-date-table td span:hover,.el-date-table td div:hover,.el-date-table td.available:hover,.el-picker-panel__shortcut:hover{color: var(--red);}
.el-date-editor .el-range__icon{line-height: 27px;}
</style>
